import { SemanticICONS } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { isNullOrUndefined } from 'common/util/utils';
import storeManager from '../../../store';
import { hasCurrentUserPlannerPrivilege } from '../../../services/permissions/PermissionService';
import { RootState } from '../../../store/rootReducer';
import { onSyncActionClick } from '../../../store/syncButton/actions';
import { ExternalSystem } from '../../../store/common/constants';
import { GradingStatus } from '../../../store/context/types';

const onActionClick = (actionName: string) => () => {
    storeManager.dispatch(onSyncActionClick(actionName));
};

export enum SyncClickActions {
    TRANSFER_LOG = 'syncButton/TRANSFER_LOG',
    TRANSFER_LOG_ERRORS = 'syncButton/TRANSFER_LOG_ERRORS',
    SYNC_UPDATE = 'syncButton/SYNC_UPDATE',
    SYNC_SETTINGS = 'syncButton/SYNC_SETTINGS',
    SYNC_SYNCHRONISATION_LOG = 'syncButton/SYNC_SYNCHRONISATION_LOG',
    SYNC_ERROR_LOG = 'syncButton/SYNC_ERROR_LOG',
    OPEN_COMMITTEE_SELECTOR = 'syncButton/openCommitteeSelector',
    TRANSFER_GRADES_TO_EXTERNAL_SYSTEM = 'syncButton/TRANSFER_GRADES_TO_EXTERNAL_SYSTEM',
    TRANSFER_GRADES_FROM_COMMITTEE = 'syncButton/TRANSFER_GRADES_FROM_COMMITTEE',

    SYNC_ACTION_CLICKED = 'syncButton/SYNC_ACTION_CLICKED',
}

export const getTransferActions = () => {
    const { assessment } = useSelector((state: RootState) => state);
    const openCommitteeSelectorOption = assessment.committees && assessment.committees.length !== 0
        ? [
            {
                actionName: SyncClickActions.OPEN_COMMITTEE_SELECTOR,
                onClick: onActionClick(
                    SyncClickActions.OPEN_COMMITTEE_SELECTOR
                ),
            },
        ]
        : [];
    return [
        ...openCommitteeSelectorOption,
        {
            actionName: SyncClickActions.TRANSFER_LOG,
            onClick: onActionClick(SyncClickActions.TRANSFER_LOG),
            iconName: 'external alternate' as SemanticICONS,
        },
        {
            actionName: SyncClickActions.TRANSFER_LOG_ERRORS,
            onClick: onActionClick(SyncClickActions.TRANSFER_LOG_ERRORS),
            iconName: 'external alternate' as SemanticICONS,
        },
    ];
};

export const getSyncActions = () => {
    const { assessment } = storeManager.getState() as RootState;

    return [
        {
            actionName: SyncClickActions.SYNC_UPDATE,
            onClick: onActionClick(SyncClickActions.SYNC_UPDATE),
            iconName: 'sync' as SemanticICONS,
            disabled:
                assessment.syncedWithExternalSystem
                && !hasCurrentUserPlannerPrivilege(),
        },
        {
            actionName: SyncClickActions.SYNC_SETTINGS,
            onClick: onActionClick(SyncClickActions.SYNC_SETTINGS),
            iconName: 'setting' as SemanticICONS,
        },
        {
            actionName: SyncClickActions.SYNC_SYNCHRONISATION_LOG,
            onClick: onActionClick(SyncClickActions.SYNC_SYNCHRONISATION_LOG),
            iconName: 'external alternate' as SemanticICONS,
        },
        {
            actionName: SyncClickActions.SYNC_ERROR_LOG,
            onClick: onActionClick(SyncClickActions.SYNC_ERROR_LOG),
            iconName: 'external alternate' as SemanticICONS,
        },
    ];
};

export const isSyncAllowedForAssessmentRun = () => {
    const { assessment, session } = storeManager.getState() as RootState;
    const { externalSystem, assessmentRunGradingStatus, externalTest } = assessment;

    if (session.user.isStudent) {
        return false;
    }

    const externalSystemSyncAllowed = !isNullOrUndefined(externalSystem)
        && (externalSystem === ExternalSystem.FS
            || externalSystem === ExternalSystem.PCG)
        && externalTest;

    let isSyncAllowedForStatus = false;
    switch (assessmentRunGradingStatus) {
    case GradingStatus.ACTIVE:
    case GradingStatus.FINISHED:
    case GradingStatus.GRADING_IN_PROGRESS:
    case GradingStatus.GRADED:
        isSyncAllowedForStatus = true;
        break;
    }
    return externalSystemSyncAllowed && isSyncAllowedForStatus;
};

export const getExternalSystemName = (externalSystem: ExternalSystem): ExternalSystem => {
    const { assessment } = storeManager.getState() as RootState;
    if (externalSystem === ExternalSystem.API && assessment.amqpEnabled) {
        return ExternalSystem.LADOK;
    }
    return externalSystem;
};
